import ReactSelect from "components/Form/Select/Select";
import React, { useEffect, useState } from "react";
import { Col, FormGroup, Input, ModalBody, ModalFooter, ModalHeader, Row, Button, Label } from "reactstrap";
import './ConfigurarPedidos.css';
import NumberFormat from "react-number-format";
import rotas from "services/rotas";
import rest from "lib/rest";
import Swal from "sweetalert2";

const CofigurarPedidos = ({ onClose }) => {

  const listaAbc = [
    { id: "A", title: "A" },
    { id: "B", title: "B" },
    { id: "C", title: "C" },
    { id: "D", title: "D" },
    { id: "E", title: "E" },
    { id: "F", title: "F" },
    { id: "G", title: "G" },
    { id: "H", title: "H" },
    { id: "I", title: "I" },
    { id: "J", title: "J" },
    { id: "K", title: "K" },
    { id: "L", title: "L" },
    { id: "M", title: "M" },
    { id: "N", title: "N" },
    { id: "O", title: "O" },
    { id: "P", title: "P" },
    { id: "Q", title: "Q" },
    { id: "R", title: "R" },
    { id: "S", title: "S" },
    { id: "T", title: "T" },
    { id: "U", title: "U" },
    { id: "V", title: "V" },
    { id: "W", title: "W" },
    { id: "X", title: "X" },
    { id: "Y", title: "Y" },
    { id: "Z", title: "Z" }
  ]

  const initialConfig = {
    ANALISE_CURVA_ABC:"",
ANALISE_INIBIR_VENDAS_CONVENIO:"",
ANALISE_MULTIPLICA_EST_MINIMO:"",
ANALISE_MULTIPLOS_PEDIDOS:"S  ",
ANALISE_NFE_LISTA_CFOP:[],
ANALISE_PRODUTOS_EQUIVALENTES:"",
ANALISE_ULTIMO_FORNECEDOR:"",
ANALISE_VERIFICAR_NFE:"",
COLUNA_ABC:"",
COLUNA_APRESENTACAO:"",
COLUNA_CATEGORIA:"",
COLUNA_CICLO:"",
COLUNA_CODBARRAS:"",
COLUNA_CODBARRAS_HOSPITALAR:"",
COLUNA_EQUIVALENTE:"",
COLUNA_EST_MINIMO:"",
COLUNA_FABRICANTE:"",
COLUNA_LUCRO:"",
COLUNA_MEDIA_VENDA:"",
COLUNA_PEDIR:"",
COLUNA_PRODUTO:"",
COLUNA_PRODUTO_ID:"",
COLUNA_SALDO:"",
COLUNA_TOTAL_VENDA:"",
COLUNA_ULT_COMPRA:"",
COLUNA_ULT_FORNECEDOR:"",
COLUNA_ULT_PRLIQUIDO:"",
CURVA_A_NOME:"",
CURVA_A_VALOR:"",
CURVA_B_NOME:"",
CURVA_B_VALOR:"",
CURVA_C_NOME:"",
CURVA_C_VALOR:"",
CURVA_TIPO:"",
SMARTPED_TOKEN:"",
SMARTPED_URL:""
}

  const [listaConfig, setListaConfig] = useState(initialConfig);
  const [novoCfop, setNovoCfop] = useState('');

  useEffect(() => {
    listarConfig();
  }, [])

  const listarConfig = () => {
    const url = rotas.pedidoConfig;

    const retorno = rest.get(url);

    retorno.then(ret => {
      let params = {};

      if (ret.success == 'S') {
        ret.lista.map(item => {
          if ((item.nome == 'ANALISE_NFE_LISTA_CFOP') && (item.parametro != '')) {
            item.parametro = item.parametro.split(',')
          }
          params[item.nome] = item.parametro

        })
        
        setListaConfig(params);
      }
    })
  }

  const onChangeConfig = (e, campo) => {    
    if (campo == 'CURVA_TIPO') {
      let lst = { ...listaConfig };
      if (e.target.name == 'abc_representatividade') {
        lst.CURVA_TIPO = e.target.checked == true ? 'R' : 'L';
      } else {
        lst.CURVA_TIPO = e.target.checked == true ? 'L' : 'R';
      }
      setListaConfig(lst);      
    } else if(e.target.type == 'checkbox') {
      let lst = { ...listaConfig };

      lst[campo] = e.target.checked == true ? 'S' : 'N';

      setListaConfig(lst);      
    }else{
      let lst = { ...listaConfig };      

      lst[campo] = e.target.value;

      setListaConfig(lst); 
    }
  }

  const onChangeSelectConfig = (e, campo) => {
    let lst = { ...listaConfig };

    lst[campo] = e.title;

    setListaConfig(lst);
  }

  const removeCfop = (cfop) => {
    let lst = { ...listaConfig };
    let cfops = lst.ANALISE_NFE_LISTA_CFOP;
    let index = cfops.indexOf(cfop);
    if (index > -1) {
      cfops.splice(index, 1);
    }
    lst.ANALISE_NFE_LISTA_CFOP = cfops;
    setListaConfig(lst);
  }

  const onChangeNovoCfop = (e) => {
    setNovoCfop(e.target.value);
  }

  const adicionaNovoCfop = () => {
    if ((novoCfop.length == 4) && ((novoCfop[0] == '5') || (novoCfop[0] == '6'))) {
      let lst = { ...listaConfig };
      let cfops = lst.ANALISE_NFE_LISTA_CFOP;
      if (!cfops.includes(novoCfop)) {
        cfops.push(novoCfop);
        lst.ANALISE_NFE_LISTA_CFOP = cfops;
        setListaConfig(lst);
        setNovoCfop('');
      }
    } else {
      Swal.fire('Atenção,', 'CFOP inválido!', 'warning');
    }
  }

  const gravarConfig = () => {

    Swal.fire({
      title: "Confirma a gravação das configurações?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "SIM",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const url = rotas.pedidoConfig;
        let params = [];
        for (const [key, value] of Object.entries(listaConfig)) {
          if (key == 'ANALISE_NFE_LISTA_CFOP') {
            let vl = value.join(',');
            let item = {
              nome: key,
              parametro: vl
            }
            params.push(item);
          } else {
            let item = {
              nome: key,
              parametro: value
            }
            params.push(item);
          }
        }
        return rest.post(url, params);

      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value.success == 'S') {
          Swal.fire('Sucesso', 'Registro Gravado com Sucesso!', 'success');
        } else {
          Swal.fire('Atenção', 'Erro ao gravar o registro!', 'warning');
        }
      }
    });
  }

  return (
    <>
      <ModalHeader>Opções de Configuração do Assistente de Pedidos</ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            <FormGroup check inline className="">
              <Label check>
                <Input
                  id="ultimo_fornecedor"
                  type="checkbox"
                  name='ultimo_fornecedor'
                  onChange={(e) => { onChangeConfig(e, 'ANALISE_ULTIMO_FORNECEDOR') }}
                  checked={listaConfig.ANALISE_ULTIMO_FORNECEDOR == 'S'}
                />
                <span className="form-check-sign" />Analisar Últ. Forn. e Últ. Pr Líq.
              </Label>
            </FormGroup>{" "}
          </Col>

          <Col>
            <FormGroup check inline className="">
              <Label check>
                <Input
                  id="equivalentes"
                  type="checkbox"
                  name='equivalentes'
                  onChange={(e) => { onChangeConfig(e, 'ANALISE_PRODUTOS_EQUIVALENTES') }}
                  checked={listaConfig.ANALISE_PRODUTOS_EQUIVALENTES == 'S' ? true : false}
                />
                <span className="form-check-sign" />Analisar Produtos Equivalentes
              </Label>
            </FormGroup>{" "}
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup check inline className="">
              <Label check>
                <Input
                  id="estoque_minimo_dias"
                  type="checkbox"
                  name='estoque_minimo_dias'
                  onChange={(e) => { onChangeConfig(e, 'ANALISE_MULTIPLICA_EST_MINIMO') }}
                  checked={listaConfig.ANALISE_MULTIPLICA_EST_MINIMO == 'S' ? true : false}
                />
                <span className="form-check-sign" />Multiplicar Est. Mín. Dias de Reposição
              </Label>
            </FormGroup>{" "}
          </Col>

          <Col>
            <FormGroup check inline className="">
              <Label check>
                <Input
                  id="notas_saida"
                  type="checkbox"
                  name='notas_saida'
                  onChange={(e) => { onChangeConfig(e, 'ANALISE_VERIFICAR_NFE') }}
                  checked={listaConfig.ANALISE_VERIFICAR_NFE == 'S' ? true : false}
                />
                <span className="form-check-sign" />Analisar Notas de Saída
              </Label>
            </FormGroup>{" "}
          </Col>
        </Row>
        <Row>        
          <Col>
            <FormGroup check inline className="">
              <Label check>
                <Input
                  id="vendas_convenio"
                  type="checkbox"
                  name='vendas_convenio'
                  onChange={(e) => { onChangeConfig(e, 'ANALISE_INIBIR_VENDAS_CONVENIO') }}
                  checked={listaConfig.ANALISE_INIBIR_VENDAS_CONVENIO == 'S' ? true : false}
                />
                <span className="form-check-sign" />Não Analisar Vendas por Convênio
              </Label>
            </FormGroup>{" "}
          </Col>


          <Col>
            <FormGroup check inline className="">
              <Label check>
                <Input
                  id="curva_abc"
                  type="checkbox"
                  name='curva_abc'
                  onChange={(e) => { onChangeConfig(e, 'ANALISE_CURVA_ABC') }}
                  checked={listaConfig.ANALISE_CURVA_ABC == 'S' ? true : false}
                />
                <span className="form-check-sign" />Analisar Curva ABC
              </Label>
            </FormGroup>{" "}
          </Col>


        </Row>

        <span className="span-divider"></span>
        <h6 className="text-center text-muted">Curva ABC</h6>

        <Row>


          <Col>

            <FormGroup check inline className="">
              <Label check>
                <Input
                  id="representatividade"
                  type="checkbox"
                  name='abc_representatividade'
                  onChange={(e) => { onChangeConfig(e, 'CURVA_TIPO') }}
                  checked={listaConfig.CURVA_TIPO == 'R' ? true : false}
                />
                <span className="form-check-sign" />Por Representatividade
              </Label>
            </FormGroup>{" "}
          </Col>

          <Col>
            <FormGroup check inline className="">
              <Label check>
                <Input
                  id="unidades_vendidas"
                  type="checkbox"
                  name='abc_unidades_vendidas'
                  onChange={(e) => { onChangeConfig(e, 'CURVA_TIPO') }}
                  checked={listaConfig.CURVA_TIPO == 'L' ? true : false}
                />
                <span className="form-check-sign" />Por Unidades Vendidas
              </Label>
            </FormGroup>{" "}

          </Col>
        </Row>

        <Row>
          <Col>
            <FormGroup>
              <ReactSelect
                name="curva_a"
                placeholder=""
                options={listaAbc}
                value={{ id: listaConfig.CURVA_A_NOME, title: listaConfig.CURVA_A_NOME }}
                onChange={(e) => { onChangeSelectConfig(e, 'CURVA_A_NOME') }}
              ></ReactSelect>
            </FormGroup>

            <FormGroup className="">
        
              <NumberFormat
                required
                name="valor_curva_a"
                placeholder=""
                value={listaConfig.CURVA_A_VALOR}
                onChange={(e)=>{onChangeConfig(e,'CURVA_A_VALOR')}}                               
                maxLength={4}
                decimalScale={0}
                allowNegative={false}
                className={"form-control"}
                suffix="%"
                // prefix={"R$ "}
                decimalSeparator={','}
              // fixedDecimalScale
              />
            </FormGroup>
          </Col>

          <Col>
            <FormGroup>
              <ReactSelect
                name="curva_b"
                placeholder=""
                options={listaAbc}
                value={{ id: listaConfig.CURVA_B_NOME, title: listaConfig.CURVA_B_NOME }}
                onChange={(e) => { onChangeSelectConfig(e, 'CURVA_B_NOME') }}
              ></ReactSelect>
            </FormGroup>

            <FormGroup className="">
        
              <NumberFormat
                required
                name="valor_curva_b"
                placeholder=""
                value={listaConfig.CURVA_B_VALOR}
                onChange={(e)=>{onChangeConfig(e,'CURVA_B_VALOR')}}                                
                maxLength={4}
                decimalScale={0}
                allowNegative={false}
                className={"form-control"}
                suffix="%"
                // prefix={"R$ "}
                decimalSeparator={','}
              // fixedDecimalScale
              />
            </FormGroup>
          </Col>

          <Col>

            <FormGroup>
              <ReactSelect
                name="curva_c"
                placeholder=""
                options={listaAbc}
                value={{ id: listaConfig.CURVA_C_NOME, title: listaConfig.CURVA_C_NOME }}
                onChange={(e) => { onChangeSelectConfig(e, 'CURVA_C_NOME') }}
              ></ReactSelect>
            </FormGroup>

            <FormGroup className="">
        
              <NumberFormat
                required
                name="valor_curva_c"
                placeholder=""
                value={listaConfig.CURVA_C_VALOR}
                onChange={(e)=>{onChangeConfig(e,'CURVA_C_VALOR')}}                              
                maxLength={4}
                decimalScale={0}
                allowNegative={false}
                className={"form-control"}
                suffix="%"
                // prefix={"R$ "}
                decimalSeparator={','}
              // fixedDecimalScale
              />
            </FormGroup>
          </Col>
        </Row>

        <span className="span-divider"></span>
        <h6 className="text-center text-muted">Lista de CFOP's de saída</h6>

        <Row>
          <Col md="5" className="align-content-center">
            <FormGroup className="mb-0">
        
              <Input
                id="cfop_saida"
                name="cfop_saida"
                placeholder="Adicione um CFOP à lista"
                value={novoCfop}
                onChange={onChangeNovoCfop}
              //defaultValue={calculaMargemApurada()}              
              />
            </FormGroup>
          </Col>

          <Col md="2" className="align-content-center justify-content-center">

            <Button block color='info' onClick={adicionaNovoCfop}><i className="fa fa-arrow-right"></i></Button>

          </Col>

          <Col md="5" className="align-content-center">
            <div className="border p-2">
              {listaConfig.ANALISE_NFE_LISTA_CFOP && listaConfig.ANALISE_NFE_LISTA_CFOP.map((item, key) => (
                <Label
                  className="mr-2"
                  key={`item-cfop-${key}`}
                >{item}
                  <i className="fa fa-times ml-1 text-muted" onClick={() => { removeCfop(item) }} />
                </Label>
              ))}
            </div>
          </Col>
        </Row>

          <span className="span-divider"></span>
          <h6 className="text-center text-muted">SmartPed</h6>
        <Row>
          
          <Col md="6" className="align-content-center">
            <FormGroup className="mb-0">
        
              <Input
                id="SMARTPED_URL"
                name="SMARTPED_URL"
                placeholder="URL SmartPed"
                value={listaConfig.SMARTPED_URL}
                onChange={(e)=>{onChangeConfig(e,'SMARTPED_URL')}}
              //defaultValue={calculaMargemApurada()}              
              />
            </FormGroup>
          </Col>

          <Col md="6" className="align-content-center">
            <FormGroup className="mb-0">
        
              <Input
                id="SMARTPED_TOKEN"
                name="SMARTPED_TOKEN"
                placeholder="Token SmartPed"
                value={listaConfig.SMARTPED_TOKEN}
                onChange={(e)=>{onChangeConfig(e,'SMARTPED_TOKEN')}}
              //defaultValue={calculaMargemApurada()}              
              />
            </FormGroup>
          </Col>
          
        </Row>

      </ModalBody >

      <ModalFooter>
        <Row>
          <Col className="mr-2">
            <Button className="bg-success" onClick={gravarConfig}>Gravar</Button>
            <Button className="bg-danger" onClick={onClose}>Fechar</Button>
          </Col>
        </Row>

      </ModalFooter>

    </>

  )
}

export default CofigurarPedidos;